import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';

// Utils
import { findIndex } from 'lodash';
import { PropertyType } from '@gql';

// UI
import { PropertySelectionCard } from './property-type-selection/property-selection-card';
type Props = {
  allPropertyTypes: PropertyType[];
  currentPropertyTypes: PropertyType[];
  togglePropertyTypeFilter: (propertyType: PropertyType) => void;
};
export const PropertyTypeSelection: React.FC<Props> = t0 => {
  const $ = _c(9);
  const {
    allPropertyTypes,
    currentPropertyTypes,
    togglePropertyTypeFilter
  } = t0;
  let t1;
  if ($[0] !== allPropertyTypes || $[1] !== currentPropertyTypes || $[2] !== togglePropertyTypeFilter) {
    let t2;
    if ($[4] !== currentPropertyTypes || $[5] !== togglePropertyTypeFilter) {
      t2 = (propertyType, _) => {
        const active = findIndex(currentPropertyTypes, o => o === propertyType) > -1;
        return <PropertySelectionCard key={propertyType} propertyType={propertyType} selected={active} onClick={() => togglePropertyTypeFilter(propertyType)} />;
      };
      $[4] = currentPropertyTypes;
      $[5] = togglePropertyTypeFilter;
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    t1 = allPropertyTypes.map(t2);
    $[0] = allPropertyTypes;
    $[1] = currentPropertyTypes;
    $[2] = togglePropertyTypeFilter;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[7] !== t1) {
    t2 = <div className="mt-4 grid grid-cols-3 md:grid-cols-5 gap-3 sm:gap-4">{t1}</div>;
    $[7] = t1;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};